import { useToast } from "primevue/usetoast";

export const errorToast = function(data, toast) {
    if(data.errors) {
        const errors =  data.errors;
        for(var error_key in errors) {
            const message = '';;
            for(var message_key in errors[error_key]) {
                toast.add({severity:'error', summary: 'Error : ' + error_key, detail: errors[error_key][message_key], life: 3000});
            }
        }
    }else if(data.message) {
        toast.add({severity:'error', summary: 'Error', detail: data.message, life: 3000});
    }
}
